import { render, staticRenderFns } from "./edit-reminder.vue?vue&type=template&id=8897cd82&scoped=true"
import script from "./edit-reminder.vue?vue&type=script&lang=js"
export * from "./edit-reminder.vue?vue&type=script&lang=js"
import style0 from "./edit-reminder.vue?vue&type=style&index=0&id=8897cd82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8897cd82",
  null
  
)

export default component.exports